import { state } from "./state.js";

const STORAGE_KEY = "mgtt_progress";

export const loadStats = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    try {
      state.userProgress = JSON.parse(stored);
      // Ensure testHistory exists (migration)
      if (!state.userProgress.testHistory) {
        state.userProgress.testHistory = [];
      }
    } catch (e) {
      console.error("Failed to load progress, starting fresh:", e);
      state.userProgress = { stats: { correct: 0, total: 0 }, history: {}, testHistory: [] };
    }
  } else {
    state.userProgress = { stats: { correct: 0, total: 0 }, history: {}, testHistory: [] };
  }
};

export const saveStats = () => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state.userProgress));
};

export const saveTheme = (theme) => {
  localStorage.setItem("mgtt_theme", theme);
};

export const loadTheme = () => {
  return localStorage.getItem("mgtt_theme") || "system";
};

export const getQuestionHistory = (id) => {
  return state.userProgress.history[id] || [];
};
